import React from 'react';
import { addMonths, endOfDay, isValid } from 'date-fns';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ActionMenu from '../../../common/action/ActionMenu';
import StatusCell from '../../../common/cells/StatusCell';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../common/filters/TextColumnFilter';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../common/filters/DateRangeColumnFilter';
import * as MyCells from '../../../../utils/Cells';

const needsDeadlineWarning = (value) => {
    const date = new Date(value);

    if (!isValid(date)) {
        return false;
    }

    return date <= endOfDay(addMonths(new Date(), 1));
};

const DeadlineDateCell = ({ value }) => {
    const needsAttention = needsDeadlineWarning(value);

    return (
        <strong
            className={needsAttention ? 'highlighted' : ''}
            style={{ alignItems: 'center', display: 'inline-flex', whiteSpace: 'nowrap' }}>
            {needsAttention && <ErrorOutlineIcon fontSize="small" style={{ marginRight: 4, verticalAlign: 'text-bottom' }} />}
            <MyCells.DateCell value={value} />
        </strong>
    );
};

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'state',
            id: 'state',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Rendszám',
            accessor: 'licenseNumber',
            id: 'licenseNumber',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Söfőr',
            accessor: 'defaultDriverEmployeeName',
            id: 'defaultDriverEmployeeName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Vásárlás dátuma',
            accessor: 'purchaseDate',
            id: 'purchaseDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Legutolsó km adat dátuma',
            accessor: 'latestKmDate',
            id: 'latestKmDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Legutolsó km adat',
            accessor: 'latestKm',
            id: 'latestKm',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Becsült mai km adat',
            accessor: 'estimatedKm',
            id: 'estimatedKm',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Műszaki lejárat dátuma',
            accessor: 'vehicleSafetyInspectionDeadline',
            id: 'vehicleSafetyInspectionDeadline',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <DeadlineDateCell value={props.value} />,
        },
        {
            Header: 'Következő szerviz dátuma',
            accessor: 'nextServiceDate',
            id: 'nextServiceDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Következő szerviz km',
            accessor: 'nextServiceKm',
            id: 'nextServiceKm',
            show: true,
            className: 'right amountColumn',
            Filter: TextColumnFilter,
            Cell: props => <MyCells.NumberCell value={props.value} />,
        },
        {
            Header: 'Kötelező biztosítás lejárat dátuma',
            accessor: 'liabilityInsuranceEndDate',
            id: 'liabilityInsuranceEndDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <DeadlineDateCell value={props.value} />,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'car'} refresh={refresh} />,
        },
    ]
}
